// extracted by mini-css-extract-plugin
export default {"VideoAd":"InfiniteBlockLayout-module__VideoAd__Aqnbm","InfiniteScrollAd":"InfiniteBlockLayout-module__InfiniteScrollAd__BCTKj"};